import { JurisdictionApi } from "../../../../Shared/Constants/api";
import axiosInstance from "../../../../Shared/Utils/axiosInstance";

export const deleteJurisdictionApi = async (id) => {
  try {
    let response = await axiosInstance.delete(`${JurisdictionApi}/${id}`);

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
